import React from 'react';
import {useTranslation} from "react-i18next";
import {IconButton, Tooltip, Typography} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {CompactNavigatorWrapper} from "./CompactNavigator.styled";

interface CompactNavigatorProps {
    currentIndex: number;
    total: number;
    hasPrevious: boolean;
    hasNext: boolean;
    onPrevious: () => void;
    onNext: () => void;
}

const CompactNavigator = ({ currentIndex, total, hasPrevious, hasNext, onPrevious, onNext }: CompactNavigatorProps) => {
    const {t} = useTranslation();

    return (
        <CompactNavigatorWrapper>
            <Tooltip title={t('digitizationDetails.navigation.prevDocument')}>
                <span>
                    <IconButton
                        color="primary"
                        size="small"
                        onClick={onPrevious}
                        disabled={!hasPrevious}
                        aria-label={t('digitizationDetails.navigation.prevDocument') as string}
                    >
                        <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                </span>
            </Tooltip>

            <Typography variant="body2" sx={{ minWidth: '40px', textAlign: 'center', userSelect: 'none' }}>
                {currentIndex}/{total}
            </Typography>

            <Tooltip title={t('digitizationDetails.navigation.nextDocument')}>
                <span>
                    <IconButton
                        color="primary"
                        size="small"
                        onClick={onNext}
                        disabled={!hasNext}
                        aria-label={t('digitizationDetails.navigation.nextDocument') as string}
                    >
                        <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
                   </IconButton>
                </span>
            </Tooltip>
        </CompactNavigatorWrapper>
    );
};

export default CompactNavigator;